<template>
  <el-row>
    <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4' v-loading="loadingAssignedApplications">
      <applications-lane :assignedApplications="assignedApplications" :assignedApps="assignedApps"></applications-lane>
    </el-col>
    <transition name="el-fade-in-linear">
      <el-col :xs='24' :sm='15' :md='17' :lg='18' :xl='16' v-loading="loadingWorkingApplication">
        <div class="grid-content bg-purple">
          <el-card class="box-card bg-purple" v-if="showWorkingApplication">
            <div slot="header" class="clearfix">
              <UserAppInfo></UserAppInfo>
            </div>
            <div class="text item">
              <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true :tab-position="tabPosition">
                <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
                  <personal-details :personalDetails="workingApplication.personalDetails"></personal-details>
                </el-tab-pane>
                <el-tab-pane v-if="!isReappraisal" label="Τίτλος Σπουδών" name="second">
                  <titles :application="workingApplication"></titles>
                </el-tab-pane>
                <el-tab-pane label="Συνυποβολή Τίτλου" name="third"
                  v-if='workingApplication.degreeType === "bachelor" && workingApplication.consideration'>
                  <title-consideration :application="workingApplication"></title-consideration>
                </el-tab-pane>
                <el-tab-pane label="Επισυναπτόμενα" name="fourth">
                  <attached-documents
                    :userComment="workingApplication.userComment"
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :appId="workingApplication.id"
                    :role="role"
                    :generalCommentProp="[]"
                    :neededDocuments="workingApplication.neededDocuments"
                    @changedAttachedDocs='changedAttachedDocsEvent'>
                  </attached-documents>
                </el-tab-pane>
                <el-tab-pane label="Ιστορικό" name="fifth" :lazy=true>
                  <history-line :applicationHistory="history"></history-line>
                </el-tab-pane>
                <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="seventh">
                  <academic-director-judgement :application='workingApplication'
                    :judgementDocs="judgementDocs"
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :generalComment="generalComment">
                  </academic-director-judgement>
                </el-tab-pane>
                 <el-tab-pane label="Σχετική αίτηση" name="eighth" v-if="isReappraisal">
                  <relevant-app :relevantApp="workingApplication.relevantApplication"></relevant-app>
              </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <application-search v-show="searchVisible"></application-search>
        <search-uni v-show="searchUniVisible"></search-uni>
      </el-col>
    </transition>
  </el-row>
</template>

<script>
import { mapState } from 'vuex'
import PersonalDetails from './common/PersonalDetails'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import ViewerJudgment from './roleSpecific/ViewerJudgment'
import ApplicationsLane from './common/ApplicationsLane'
import UserAppInfo from './common/UserAppInfo'
import ApplicationSearch from '@/components/common/ApplicationSearch'
import SearchUni from '@/components/common/SearchUni'
import RelevantApp from './common/RelevantApp'
import AcademicDirectorJudgement from './roleSpecific/AcademicDirectorJudgement'

export default {
  name: 'Viewer',
  components: {
    PersonalDetails,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    ViewerJudgment,
    ApplicationsLane,
    UserAppInfo,
    ApplicationSearch,
    SearchUni,
    RelevantApp,
    AcademicDirectorJudgement
  },
  mounted: function () {
  },
  data () {
    return {
      assignedApps: {
        // academicDirectorW_Proponent: [{ id: '1', surname: '', createdAt: '', degreeType: '' }],
        academicDirectorW_President: [{ id: '1', surname: '', createdAt: '', degreeType: '' }],
        academicDirectorW_ReappraisalBoard: [{ id: '2', surname: '', createdAt: '', degreeType: '' }],
        academicDirectorW_Proponent: [{ id: '3', surname: '', createdAt: '', degreeType: '' }]
      },
      role: 'processViewer',
      tabPosition: 'top',
      activeName: 'sixth',
      notificationsDialogVisible: false,
      openNewApplications: false,
      listAssignedApplications: [],
      listPrecheckersApplications: [],
      viewApplication: {},
      applicationView: false,
      myApplications: [],
      allApplications: [],
      loadingAllApplications: false,
      judgementDocs: this.attachedDocumentsTable,
      generalComment: ''
    }
  },
  methods: {
    changedGeneralCommentEvent (comment) {
      this.generalComment = comment
    },
    changedAttachedDocsEvent (docs) {
      let docComments = ''
      docs.forEach(doc => {
        if (doc.precheckerComment) {
          // Todo: this comment must be in English according to language
          docComments +=
            `<div><b>Τύπος</b>: ${doc.type}, <b>Κατάσταση</b>: ${doc.precheckerChecked ? 'Αποδεκτό' : 'Με εκκρεμότητα'}, <b>Σχόλιο</b>: ${doc.precheckerComment}</div>`
        }
      })
      this.judgementDocs = docComments
    },
    loadViewApplication (id) {
    },
    viewNewApp (data) {
    },
    toggleNewApplications () {
      this.openNewApplications = !this.openNewApplications
    },
    handleClick (tab, event) {
    }
  },
  computed: {
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    ...mapState([
      'searchVisible',
      'searchUniVisible',
      'history',
      'assignedApplications',
      'workingApplication',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication'
    ])
  },
  watch: {
    workingApplication: function (newData, oldData) {
      this.activeName = 'first'
    },
    assignedApplications: {
      handler: function (newData, oldData) {
        this.listAssignedApplications = this.assignedApplications.map(
          application => { return { key: application.id, label: `${application.degreeType}, ${application.surname}, ${application.createdAt.substring(0, 10)}`, disabled: false } })
        this.myApplications = []
        this.assignedApplications.forEach(app => {
          this.myApplications.push(app.id)
        })
      },
      deeep: true
    }
  }
}
</script>

<style lang="scss">
.el-transfer-panel .el-transfer-panel__footer {
  text-align: center;
}
div.el-transfer-panel {
  width: 350px
}
.newApplicationsMenu {
  background-color: #c8ec3c;
  /*color: #7a9db7;*/
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.commentText {
  width: 320px;
}
.el-card__body {
  padding: 2px;
}
.el-card {
  margin: 5px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.list-group {
  min-height: 20px;
  overflow: hidden;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AcademicDirector.vue